import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'

Vue.use(VueRouter)

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

const constantRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
      path: '/login',
      component:resolve => require(['@/views/Login'],resolve),
      hidden: true
  },
  {
      path: '/Device/Connector',
      component:resolve => require(['@/views/Device/Connector'],resolve)
  },
  {
      path: '/PrivacyProtocol',
      component:resolve => require(['@/views/PrivacyProtocol/Index'],resolve)
  },
  {
    path: '/Preview',
    component:resolve => require(['@/views/CommunityRetirement/VideoCamera/Preview'],resolve),
    meta: {
      name: "renderer",
      content:"ie-comp"
    },
  },
  {
    path: '/Playback',
    component:resolve => require(['@/views/CommunityRetirement/VideoCamera/Playback'],resolve)
  },
  {
    path: '/Institution',
    name: 'Institution',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/Institution/Index',
    children: [
        {
          path: 'Index',
          component:resolve => require(['@/views/Institution/Index'],resolve),
        },
    ]
  },
  {
    path: '/WisdomCloud',
    name: 'WisdomCloud',
    component:resolve => require(['@/views/Home'],resolve),
    redirect: '/WisdomCloud/Index',
    children: [
        {
          path: 'Index',
          component: resolve => require(['@/views/WisdomCloud/Index'],resolve),
        },
    ]
  },
  {
    path: '/HomeCare',
    name: 'HomeCare',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/HomeCare/Index',
    children: [
        {
          path: 'Index',
          component:  resolve => require(['@/views/HomeCare/Index'],resolve),
        },
    ]
  },
  {
    path: '/CommunityRetirement',
    name: 'CommunityRetirement',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/CommunityRetirement/Index',
    children: [
        {
          path: 'Index',
          component: resolve => require(['@/views/CommunityRetirement/Index'],resolve),
        },
    ]
  },
  {
    path: '/Volunteer',
    name: 'Volunteer',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/Volunteer/Index',
    children: [
        {
          path: 'Index',
          component: resolve => require(['@/views/Volunteer/Index'],resolve),
        },
    ]
  },
    // 监控页面
    {
      path: '/Monitoring',
      name: 'Monitoring',
      component: resolve => require(['@/views/Home'],resolve),
      redirect: '/Monitoring/Index',
      children: [
          {
            path: 'Index',
            component:  resolve => require(['@/views/Monitoring/Index'],resolve),
          },
      ]
    },
  {
    path: '/OldAgeAllo',
    name: 'OldAgeAllo',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/OldAgeAllo/Index',
    children: [
        {
          path: 'Index',
          component:  resolve => require(['@/views/OldAgeAllo/Index'],resolve),
        },
    ]
  },
  {
    path: '/Location',
    name: 'Location',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/Location/Index',
    children: [
        {
          path: 'Index',
          component: resolve => require(['@/views/Location/Index'],resolve),
        },
    ]
  },
  {
    path: '/ServiceObject',
    name: 'ServiceObject',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/ServiceObject/Index',
    children: [
        {
          path: 'Index',
          component: resolve => require(['@/views/ServiceObject/Index'],resolve),
        },
        {
          path: 'IndexChildOne',
          component: resolve => require(['@/views/ServiceObject/IndexChildOne'],resolve),
        },
    ]
  },
  {
    path: '/ServiceObject',
    name: 'ServiceObject1',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/ServiceObject/IndexChildOne',
    children: [
        {
          path: 'IndexChildOne',
          component: resolve => require(['@/views/ServiceObject/IndexChildOne'],resolve),
        },
    ]
  },
  {
    path: '/IntelligentDevice',
    name: 'IntelligentDevice',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/IntelligentDevice/Index',
    children: [
        {
          path: 'Index',
          component: resolve => require(['@/views/IntelligentDevice/Index'],resolve),
        },
    ]
  },
  {
    path: '/OldAgeBed',
    name: 'OldAgeBed',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/OldAgeBed/Index',
    children: [
      {
        path: 'Index',
        component: resolve => require(['@/views/OldAgeBed/Index'],resolve),
      },
      {
        path: 'IndexChildOne',
        component: resolve => require(['@/views/OldAgeBed/IndexChildOne'],resolve),
      },
    ]
  },
  {
    path: '/Monitoring',
    name: 'Monitoring',
    component: resolve => require(['@/views/Home'],resolve),
    redirect: '/Monitoring/Index',
    children: [
      {
        path: 'Index',
        component: resolve => require(['@/views/Monitoring/Index'],resolve),
      },
    ]
  }

]
const createRouter = () => new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

